import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./relationship-selector.html';
import controller from './RelationshipSelector';
import styles from './style_hashed.scss';

/**
 * @ngdoc component
 * @name edge.gateway.contacts.common.app.component: gwRelationshipSelector
 *
 * @description  A component to allow selection among different relationship types.
 *
 * @param value {string} the selected relationship code, null for 'all' and '$common' for contacts in accounts with
 * common contacts
 * @param onChange: {expression} an expression to be evaluated when the user changes the selected option. 'value' gives
 * access to the selected value.
 *
 */
export default {
    controller,
    template: cssUtil.hashTemplate(template, styles),
    bindings: {
        value: '<',
        onChange: '&'
    }
};
